import { Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';

@Component({
    selector: 'app-fullscreen-loading',
    imports: [MaterialModule],
    templateUrl: './fullscreen-loading.component.html',
    styleUrl: './fullscreen-loading.component.scss'
})
export class FullscreenLoadingComponent {}
